import React, { Component } from 'react';
import {goCommonPage, query, setlog} from '@modules/58app';

let btncolor={color:"#0000ee"};
let phonecolor={color:"#1E90FF"}
// export default ({rightItem,message,jumpLink,...props})=>{
export default class Message extends Component {
    Jump(url){
      let tjfrom = query("tjfrom");
      if(tjfrom){
        url += `?tjfrom=${tjfrom}`;
      }
      goCommonPage(url);
    }

    CallPhone () {
        setlog("sevicephone_click");
    }
    render(){
        let {rightItem, message, jumpLink, tel}=this.props;
        return (
            <div className={`chatpanel-item chatpanel-item-message ${rightItem?"right-item":""}`}>
                <div className="item-container">
                    <div className="item-content">{message}
                    {/* 赶集新增拨打电话功能 */}
                    {
                        tel?
                        <a style={phonecolor} href='tel:400-621-2121' onClick = {() => this.CallPhone()}>400-621-2121</a>:null
                    }
                    <br/>
                    {jumpLink?
                        <p style={btncolor} onClick={()=>this.Jump(jumpLink.url)}>{jumpLink.txt}</p>:null
                    }
                    </div>
                </div>
            </div>
        )

    }
}